import { render, staticRenderFns } from "./Researchers.vue?vue&type=template&id=4f408fa2&scoped=true&"
import script from "./Researchers.vue?vue&type=script&lang=js&"
export * from "./Researchers.vue?vue&type=script&lang=js&"
import style0 from "./Researchers.vue?vue&type=style&index=0&id=4f408fa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f408fa2",
  null
  
)

export default component.exports